//
//  SDKSourceType.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Source type enum
export var SourceType;
(function (SourceType) {
    SourceType["figma"] = "Figma";
    SourceType["tokenStudio"] = "TokenStudio";
    SourceType["figmaVariablesPlugin"] = "FigmaVariablesPlugin";
    SourceType["storybook"] = "Storybook";
})(SourceType || (SourceType = {}));
